import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import { PopupID } from '../../../State/UI/PopupID';
import { DataConflictActions } from '../../../State/Game/DataConflictActions';
import { GameObjectEvent } from '../../../GameObject/GameObject';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import BaseMenu from 'System/UI/Menu/BaseMenu';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { GBCDisconnectedLayout } from 'Layouts/GBCDisconnectedLayout';
import { Anim, StartAnimationClip, StopAnimation } from 'System/Animation/AnimationHelper';
import { MainAnim } from 'System/Animation/Clip/MainAnim';
import { connectToGBC } from 'Utility/SDK/GBC/ConnectToGBC';
import { GameActions } from 'State/Game/GameActions';
import { GBCHandler } from 'Utility/SDK/GBCHandler';
import { UIActions } from 'State/UI/UIActions';

export default class GBCDisconnectedMenuHandler extends BaseMenu {
    private layout: GLayout<GBCDisconnectedLayout>;
    private isConnecting: boolean = false;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.GBC_DISCONNECTED, uiSystem, false);
    }

    async preload(): Promise<void> {
        Game.resource.add('loading_farm_icon', 'resource/graphics/other/loading_farm_icon.png');
        await super.preload();
    }

    protected onCreate() {
        super.onCreate();

        this.layout = getLayout(GBCDisconnectedLayout);
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);
        applyDefaultButtonAnimation(this.layout.reconnectBtn);
    }

    public onShow(params?: any): void {
        super.onShow(params);
        this.addEventListeners();
        this.isConnecting = false;
        this.animateToNewState();
    }

    protected onHide(params?: any): void {
        GBCHandler.isConnected().then(isConnected => {
            if (!isConnected) {
                UIActions.queuePopup(PopupID.GBC_DISCONNECTED, {});
            }
        });
    }

    protected onHidden(params?: any): void {
        this.removeEventListeners();
    }

    private readonly attemptReconnect = (): void => {
        if (this.isConnecting) {
            return;
        }
        this.isConnecting = true;
        this.animateToNewState();
        this.removeEventListeners();

        connectToGBC().catch(() => {
            //TODO: Report?
            this.isConnecting = false;
            this.animateToNewState();
            this.addEventListeners();
        });
    };

    private animateToNewState(): void {
        StartAnimationClip(
            new MainAnim(this.layout.connectingContainer, {
                alpha: Number(this.isConnecting),
                duration: 150,
            })
        );

        StartAnimationClip(
            new MainAnim(this.layout.disconnectedContainer, {
                alpha: Number(!this.isConnecting),
                duration: 150,
            })
        );

        if (this.isConnecting) {
            Anim(this.layout.loadingSpinner, {
                duration: 700,
                angle: 360,
                delay: 0,
                repeatCount: Infinity,
            });
        } else {
            StopAnimation(this.layout.loadingSpinner);
        }
    }

    private addEventListeners() {
        this.layout.reconnectBtn.on(GameObjectEvent.SELECTED, this.attemptReconnect);
    }

    private removeEventListeners() {
        this.layout.reconnectBtn.off(GameObjectEvent.SELECTED, this.attemptReconnect);
    }
}
